// extracted by mini-css-extract-plugin
export default {"showOnFocus":"b3xZaP","link":"c3xZaP"};